<template>
  <div>
    <main-layout>
      <v-container style="max-width: 1000px">
        <v-layout>
          <v-flex>
            <h3 class="headline" style="display: inline">{{ $t('Welcome Message') }}</h3>
            <v-modal-help>
              <div slot="body">
                <img class="responsive-img" src="/static/img/assets/help/h_choice.png" />
                <div style="padding: 15px;">
                  <p class="strong">สร้างคำตัวเลือก:</p>
                  <ol type="1" style="margin-bottom: 15px;">
                    <li style="list-style: decimal;">
                      กดปุ่ม “เพิ่มคำตัวเลือก” พิมพ์คำที่พบบ่อยเพื่อเป็นตัวเลือกให้ผู้ที่ทักมา
                      (จำกัดไม่เกิน 20 ตัวอักษรต่อหนึ่งคำตัวเลือก)
                    </li>
                  </ol>
                  <p>
                    ปล. “คำตัวเลือก” ที่สร้างไว้หน้านี้จะอยู่แค่ในหน้า ข้อความต้อนรับ (Welcome
                    Message) เท่านั้น หากไปหน้าอื่นคุณสามารถสร้างคำตัวเลือกในหน้านั่นๆได้ที่
                    “บทสนทนา (Conversation)”
                  </p>
                </div>
              </div>
            </v-modal-help>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              fab
              outline
              small
              color="primary"
              v-if="!isEditWelcome"
              @click="isEditWelcome = !isEditWelcome"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <p>{{ $t('First greeting message to your customers (Not exceed 20 alphabets)') }}</p>
        <template v-if="isWelcomeLoading">
          <scale-loader :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
        </template>
        <template v-else>
          <template v-if="isEditWelcome">
            <manage-intent
              :type="'edit'"
              :isCommentToInbox="false"
              v-model="welcome_intent"
              @close="cancelEdit"
              @saveIntent="saveWelcomeMessage"
              :excludedIntentName="excludedIntentName"
              :isWelcome="true"
            >
              <template v-slot:welcome="{ changeSetting, showMultipleChannel }">
                <div>
                  <intent-group
                    v-model="messages"
                    :isWelcome="true"
                    :intentname="welcome_intent.intentname"
                    :showMultipleChannel="showMultipleChannel"
                    @changeSetting="changeSetting"
                  ></intent-group>
                </div>
              </template>

              <div slot="footer" slot-scope="scope">
                <div style="margin-bottom : 15px">
                  <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                    <i class="far fa-eye"></i>
                    {{ $t('preview') }}
                  </a>
                </div>
                <v-btn outline color="grey" @click="scope.cancelEdit">{{ $t('cancel') }}</v-btn>
                <v-btn depressed color="primary" @click="scope.saveIntent">{{ $t('Save') }}</v-btn>
              </div>
            </manage-intent>
          </template>
          <template v-else>
            <v-layout wrap>
              <v-flex xs12 sm6 class="pa-1">
                <div class="question">
                  <p class="caption">{{ $t('customer says') }}</p>

                  <template v-if="normal && normal.length > 0">
                    <label class="caption">{{ $t('Sentence') }}</label>
                    <ul class="tags" style="margin-bottom:5px">
                      <li
                        class="tag"
                        v-for="(question, index) in normal"
                        :key="'normal_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template v-if="keyword && keyword.length > 0">
                    <label class="caption">{{ $t('Keyword') }}</label>
                    <ul class="tags" style="margin-bottom:5px">
                      <li
                        class="tag"
                        v-for="(question, index) in keyword"
                        :key="'keyword_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template v-if="exactly && exactly.length > 0">
                    <label class="caption">{{ $t('Exact word') }}</label>
                    <ul class="tags" style="margin-bottom:5px">
                      <li
                        class="tag"
                        v-for="(question, index) in exactly"
                        :key="'exactly_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template
                    v-if="
                      startwith && startwith.length > 0 && $store.getters.getPackage == 'premium'
                    "
                  >
                    <label class="caption">{{ $t('Start with') }}</label>
                    <ul class="tags" style="margin-bottom:5px">
                      <li
                        class="tag"
                        v-for="(question, index) in startwith"
                        :key="'startwith_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template
                    v-if="endwith && endwith.length > 0 && $store.getters.getPackage == 'premium'"
                  >
                    <label class="caption">{{ $t('End with') }}</label>
                    <ul class="tags" style="margin-bottom:5px">
                      <li
                        class="tag"
                        v-for="(question, index) in endwith"
                        :key="'endwith_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template
                    v-if="
                      startandendwith &&
                        startandendwith.length > 0 &&
                        $store.getters.getPackage == 'premium'
                    "
                  >
                    <label class="caption">{{ $t('Start and End with') }}</label>
                    <ul class="tags" style="margin-bottom:5px">
                      <li
                        class="tag"
                        v-for="(question, index) in startandendwith"
                        :key="'startandendwith_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>

                  <label v-show="isOtherLang && $store.getters.getPackage != 'premium'">
                    <i class="fas fa-exclamation-circle"></i>
                    {{
                      $t(
                        'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
                      )
                    }}
                  </label>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <div class="answer">
                  <p class="caption">{{ $t('Chatbot answers') }}</p>
                  <div>
                    <template v-if="!showMultipleChannel">
                      <template v-if="messages && messages[0].length > 0">
                        <message-viewer v-model="messages" :channel="tab"></message-viewer>
                      </template>
                      <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                    </template>
                    <template v-else>
                      <v-layout>
                        <v-flex class="channel" shrink style="border-right: 1px solid #eee">
                          <template v-for="social in $store.state.socialChannelOptions">
                            <div
                              :class="{ 'primary white--text': tab == social.value }"
                              @click="tab = social.value"
                              class="py-1 pl-2 pr-2"
                              style="
                                    border: 1px solid #eee;
                                    border-width: 1px 0px 1px 1px;
                                    border-top-left-radius: 5px;
                                    border-bottom-left-radius: 5px;
                                    cursor: pointer;
                                  "
                              :key="`tab-${social.value}`"
                            >
                              <span :class="social.icon"></span>
                            </div>
                          </template>
                        </v-flex>
                        <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                          <template v-for="social in $store.state.socialChannelOptions">
                            <template v-if="tab == social.value">
                              <template
                                v-if="
                                  multiAnswers[`${social.value}_anwsers`] &&
                                    multiAnswers[`${social.value}_anwsers`][0].length > 0
                                "
                              >
                                <message-viewer
                                  v-model="multiAnswers[`${social.value}_anwsers`]"
                                  :channel="tab"
                                  :key="`answers-${social.value}`"
                                ></message-viewer>
                              </template>
                              <p v-else class="primary-color pl-1" :key="`noreply-${social.value}`">
                                {{ $t('No reply') }}
                              </p>
                            </template>
                          </template>
                        </v-flex>
                      </v-layout>
                    </template>
                  </div>
                </div>
              </v-flex>

              <v-flex xs12>
                <template
                  v-if="welcome_intent && (welcome_intent.context_in || welcome_intent.context_out)"
                >
                  <div class="hr" style="margin-top: 10px;"></div>
                  <div class="row" style="margin-top: 15px;margin-bottom: 0px;">
                    <div class="col s12 m6">
                      <p class="small">Context In</p>
                      <p>{{ welcome_intent.context_in ? welcome_intent.context_in : '-' }}</p>
                    </div>
                    <div class="col s12 m6">
                      <p class="small">Context Out</p>
                      <p>{{ welcome_intent.context_out ? welcome_intent.context_out : '-' }}</p>
                    </div>
                  </div>
                </template>
              </v-flex>
            </v-layout>
          </template>
        </template>
      </v-container>
      <v-divider></v-divider>
      <v-container style="max-width: 1000px">
        <v-layout>
          <v-flex>
            <h3 class="headline" style="display: inline">{{ $t('Choice') }}</h3>
            <v-modal-help>
              <div slot="body">
                <img class="responsive-img" src="/static/img/assets/help/h_choice.png" />
                <div style="padding: 15px;">
                  <p class="strong">สร้างคำตัวเลือก:</p>
                  <ol type="1" style="margin-bottom: 15px;">
                    <li style="list-style: decimal;">
                      กดปุ่ม “เพิ่มคำตัวเลือก” พิมพ์คำที่พบบ่อยเพื่อเป็นตัวเลือกให้ผู้ที่ทักมา
                      (จำกัดไม่เกิน 20 ตัวอักษรต่อหนึ่งคำตัวเลือก)
                    </li>
                  </ol>
                  <p>
                    ปล. “คำตัวเลือก” ที่สร้างไว้หน้านี้จะอยู่แค่ในหน้า ข้อความต้อนรับ (Welcome
                    Message) เท่านั้น หากไปหน้าอื่นคุณสามารถสร้างคำตัวเลือกในหน้านั่นๆได้ที่
                    “บทสนทนา (Conversation)”
                  </p>
                </div>
              </div>
            </v-modal-help>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              fab
              outline
              small
              color="primary"
              v-if="!isEditChoice"
              @click="isEditChoice = !isEditChoice"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <span class="small">{{
          $t('Options for customers to quickly reply (Not exceed 20 alphabets)')
        }}</span>
        <quick-reply
          v-model="welcome_quickreplies"
          :isEdit="isEditChoice"
          @onSave="saveQuickReply"
          @onChangeChoice="onChangeChoice"
          @onCancel="isEditChoice = false"
          :showMultipleChannel="showMultipleChannel"
        >
          <div slot="footer" slot-scope="scope">
            <div style="margin-bottom : 15px">
              <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                <i class="far fa-eye"></i>
                {{ $t('preview') }}
              </a>
            </div>
            <div>
              <v-btn outline color="grey" @click="scope.cancelEdit">{{ $t('cancel') }}</v-btn>
              <v-btn depressed color="primary" @click="scope.saveContent">{{ $t('Save') }}</v-btn>
            </div>
          </div>
        </quick-reply>
      </v-container>

      <v-divider></v-divider>
      <v-container style="max-width: 1000px">
        <v-layout>
          <v-flex>
            <h3 class="headline" style="display: inline">{{ $t('Extra Menu') }}</h3>
            <v-modal-help>
              <div slot="body">
                <img class="responsive-img" src="/static/img/assets/help/h_persistent_menu.png" />
                <div style="padding: 15px;">
                  <p class="strong">“ตัวอย่างเมนูเสริมเมื่อใช้งานจริง” (รูปด้านบน)</p>
                  <p>มีการตั้งค่าปุ่มกด 2 ปุ่ม</p>
                  <p>
                    <span class="strong">ปุ่มแรก: Main Menu</span> เลือกรูปแบบการตอบกลับแบบ TEXT
                    (ข้อความ) ซึ่งเมื่อสร้างเสร็จจะต้องไปตั้งค่าหน้า “ตั้งค่าบทสนทนา (Conversation)”
                    ว่าถ้ามีคนคลิกปุ่ม “Main Menu” จะให้ Bot ตอบกลับว่าอย่างไร
                  </p>
                  <p>
                    <span class="strong">ปุ่มที่สอง: Website</span> เลือกรูปแบบการตอบกลับแบบ LINK
                    (ลิ้งค์), กรณีนี้เพียงแค่เราใส่ website ลงไปก็ถือเป็นอันเสร็จสิ้น
                    เมื่อมีคนกดปุ่มนี้ ระบบจะนำพาผู้กดเข้าไปยังเว็บไซต์ที่เรากำหนดเลยทันที
                  </p>
                </div>
              </div>
            </v-modal-help>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              fab
              outline
              small
              color="primary"
              v-if="!isEditExtraMenu"
              @click="isEditExtraMenu = !isEditExtraMenu"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <p>{{ $t('Shortcut side bar') }}</p>
        <persistent-menu
          v-model="persistent_menu"
          :isEdit="isEditExtraMenu"
          @onSave="isEditExtraMenu = false"
        ></persistent-menu>
      </v-container>

      <preview-message
        v-if="showPreview"
        @close="showPreview = false"
        :messages="messages"
        :choice="previewChoices"
        :questions="questions"
      ></preview-message>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

import specialtext from '@/components/elements/specialtext'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import QuickReply from '@/components/view/chatbot/QuickReply'

import IntentGroup from '@/components/view/intent/IntentGroup'
import ManageIntent from '@/components/view/intent/intent-manage'

import PersistentMenu from '@/components/view/setting/PersistentMenu'
import PreviewMessage from '@/components/elements/PreviewMessage'
import { cloneDeep } from 'lodash'

export default {
  data: function() {
    return {
      isEditWelcome: false,
      isEditExtraMenu: false,
      isEditChoice: false,
      showPreview: false,
      isWelcomeLoading: false,
      messages: [[]],
      message: null,
      excludedIntentName: '',
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ],
      type: 'json',

      showEmoji: false,

      welcome_quickreplies: undefined,
      persistent_menu: undefined,
      previewChoices: [],
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],
      isOtherLang: false,
      tab: 'all',
      showMultipleChannel: false
    }
  },
  components: {
    GenericViewer,
    MessageViewer,
    QuickReply,
    PersistentMenu,
    IntentGroup,
    ManageIntent,
    specialtext,
    PreviewMessage,
    ScaleLoader
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      loadingSetting: 'getLoadingSetting',
      contents: 'getSetting',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    pageid: function() {
      if (!this.$store.state.selectedBot) {
        return null
      }
      return this.$store.state.selectedBot.pageid
    },
    welcome_intent: {
      get() {
        let welcomeIntent = this.$store.getters.getIntents('welcome')
        if (welcomeIntent.length > 0) {
          return welcomeIntent[0]
        } else {
          return {
            ...cloneDeep(this.intentTemplate()),
            intentname: '{welcome}',
            a_val: '[[]]',
            ableToDelete: false,
            isShow: false
          }
        }
      },
      set(val) {
        this.$store.commit('SET_INTENT', val)
      }
    },
    answers: function() {
      return [[]]
    },
    multiAnswers() {
      const anwsers = this.$store.state.socialChannelOptions.reduce((prev, curr) => {
        let answers = [[]]
        try {
          answers = this.formatAnswer(this.welcome_intent[`${curr.value}_val`], 'json')
        } catch (error) {
          console.error(error)
        }
        prev[`${curr.value}_anwsers`] = answers
        return prev
      }, {})
      return anwsers
    },
    questions: function() {
      if (this.welcome_intent && this.welcome_intent.q_val != '') {
        return this.welcome_intent.q_val.split(',')
      } else {
        return []
      }
    }
  },

  async created() {
    var vm = this
    if (vm.selectedBot.theme == 'ecommercebasic') {
      await vm.$store.dispatch('loadCategory')
      await vm.$store.dispatch('loadProducts')
      await vm.$store.dispatch('loadCharges')
    }
    await vm.$store.dispatch('loadSetting')
    if (vm.contents.welcome_quickreplies) {
      vm.welcome_quickreplies = vm.contents.welcome_quickreplies
    }

    vm.isWelcomeLoading = true
    try {
      await this.$store.dispatch('loadIntent')
      this.welcome_quickreplies = {
        replies:
          this.contents && this.contents.welcome_quickreplies
            ? this.contents.welcome_quickreplies.contentvalue
            : this.welcome_intent.quick_reply,
        fb: this.welcome_intent.fb_quick_reply,
        line: this.welcome_intent.line_quick_reply,
        ig: this.welcome_intent.ig_quick_reply
      }
      vm.handleGetMultipleChannel()
      vm.tab = vm.showMultipleChannel ? 'fb' : 'all'
    } catch (error) {
      console.error(error)
    }

    try {
      var status = await vm.getWelcomeMessage()
      if (status) {
        vm.cached_message = vm.message
        vm.cached_generics = []
        vm.cached_messages = []
        $.each(vm.generics, function(index, generic) {
          vm.cached_generics[index] = Object.assign({}, generic)
          vm.cached_generics[index].buttons = []
          $.each(generic.buttons, function(bindex, button) {
            vm.cached_generics[index].buttons[bindex] = Object.assign({}, button)
          })
        })

        vm.cached_messages = JSON.stringify(vm.messages)

        vm.cached_type = vm.type

        vm.isWelcomeLoading = false
      }
    } catch (error) {
      console.error(error)
    }

    // vm.getPersistentMenu(function() {});
  },
  methods: {
    async saveQuickReply(reply) {
      var intent = cloneDeep(this.welcome_intent)
      intent.quick_reply = reply.replies
      intent.fb_quick_reply = reply.fb
      intent.line_quick_reply = reply.line
      intent.ig_quick_reply = reply.ig
      await this.saveIntent(intent)
      this.isEditChoice = false
    },
    saveIntent: function(intent) {
      let data = {
        ...intent
      }
      return new Promise((resolve, reject) => {
        if (!data.id) {
          api.addIntent(data, function(error, response) {
            if (error) {
              reject(error)
              return
            }
            resolve()
          })
        } else {
          api.editIntent(data, function(error, response) {
            if (error) {
              reject(error)
            }
            resolve()
          })
        }
      })
    },
    handleGetMultipleChannel() {
      const hasMultipleChannel = this.$store.state.socialChannelOptions.find(social => {
        return (
          Object.prototype.hasOwnProperty.call(this.welcome_intent, `${social.value}_val`) &&
          this.welcome_intent[`${social.value}_val`]
        )
      })
      if (hasMultipleChannel) {
        this.showMultipleChannel = true
      }
    },
    formatData: function(text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      var isPremium = vm.$store.getters.getPackage === 'premium'
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function(question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else {
            vm.normal.push({ text: question, checkLang: vm.isSupportLanguage(question, isPremium) })
            if (!vm.isSupportLanguage(question, isPremium)) {
              vm.isOtherLang = true
            }
          }
        })
      }
    },
    onChangeChoice: function(payload) {
      this.previewChoices = payload
    },
    onOptionChange: function(option) {
      this.type = option
      // this.saveWelcomeMessage()
    },
    getWelcomeMessage: function() {
      let vm = this
      if (!vm.selectedBot) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid
      }

      vm.message = null
      vm.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ]
      vm.type = 'json'
      return new Promise((resolve, reject) => {
        api.getWelcomeMessage(data, function(error, response) {
          if (error) {
            console.error(error)
            reject(false)
          }
          if (response.data) {
            if (response.data.type != 'json') {
              if (response.data.type == 'message') {
                if (response.data.message_text == '') {
                  vm.messages = [[]]
                } else {
                  var group = []
                  var group_messages = response.data.message_text.split('||')
                  $.each(group_messages, function(index, messages) {
                    var messages = messages.split('#nl')
                    var newMessages = []
                    $.each(messages, function(inedx, message) {
                      console.log(message, vm.isURL(message))
                      if (vm.isURL(message)) {
                        newMessages.push({
                          type: 'image',
                          image_url: message
                        })
                      } else if (!isNaN(message)) {
                        newMessages.push({
                          type: 'text',
                          text: message
                        })
                      } else if (vm.isJsonParseable(message)) {
                        var parsedMessage = JSON.parse(message)
                        newMessages.push({
                          type: 'button',
                          text: parsedMessage.text,
                          buttons: parsedMessage.buttons
                        })
                      } else if (message == '') {
                      } else {
                        newMessages.push({
                          type: 'text',
                          text: message
                        })
                      }
                    })
                    group.push(newMessages)
                  })

                  vm.messages = group
                }
              } else if (response.data.type == 'generic') {
                vm.messages[0][0] = {
                  type: 'generic',
                  data: response.data.message
                }
              }
            } else {
              vm.messages = JSON.parse(response.data.message)
            }
            vm.type = 'json'
          }
          resolve(true)
        })
      })
    },
    getPersistentMenu: function(callback) {
      var vm = this
      var url =
        'https://graph.facebook.com/me/messenger_profile?fields=persistent_menu&access_token=' +
        vm.$store.state.selectedBot.page_access_token
      axios.get(url).then(response => {
        if (response.status == 200) {
          var response = response.data
          if (
            response.data[0] &&
            response.data[0]['persistent_menu'] &&
            response.data[0]['persistent_menu'][0] &&
            response.data[0]['persistent_menu'][0]['call_to_actions']
          ) {
            vm.persistent_menu = response.data[0]['persistent_menu'][0]['call_to_actions']
            callback()
          }
        }
      })
    },
    addGeneric: function() {
      if (this.generics.length < 10) {
        this.generics.push({
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        })
      }
    },
    onDeleteGeneric: function(index) {
      if (this.generics.length > 1) {
        this.generics.splice(index, 1)
      } else {
        alert('Welcome Message cannot be less than 1')
      }
    },
    saveWelcomeMessage: function() {
      let vm = this
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json'
      }

      vm.$store.dispatch('loading')
      var messages = []
      $.each(vm.messages, function(index, message) {
        var group = []
        $.each(message, function(mindex, msg) {
          if (msg.type == 'text') {
            if (msg.text != '' && msg.text != null) {
              group.push(msg)
            }
          } else if (msg.type == 'button') {
            if ((msg.text != '' && msg.text != null) || msg.buttons.length > 0) {
              group.push(msg)
            }
          } else if (msg.type == 'image') {
            if (msg.image_url) {
              group.push(msg)
            }
          } else if (msg.type == 'generic') {
            var generics = []
            $.each(msg.data, function(gindex, generic) {
              if (
                generic.image_url != null ||
                generic.title != '' ||
                generic.subtitle != '' ||
                generic.buttons.length > 0
              ) {
                generics.push(generic)
              }
            })
            if (generics.length > 0) {
              group.push({
                type: 'generic',
                data: generics
              })
            }
          } else {
            group.push(msg)
          }
        })
        if (group.length > 0) {
          messages.push(group)
        }
      })

      if (messages.length == 0) {
        messages = [[]]
      }

      data['message'] = JSON.stringify(messages)

      api.saveWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        // console.log(data)
        vm.cached_type = vm.type
        vm.cached_messages = JSON.stringify(messages)
        vm.messages = messages
        vm.$store.dispatch('updateWelcomeMessage', {
          type: 'json',
          message: null,
          generics: null,
          messages: messages
        })

        vm.handleGetMultipleChannel()
        vm.tab = vm.showMultipleChannel ? 'fb' : 'all'

        vm.isEditWelcome = false
        vm.$store.dispatch('loading')
      })
    },
    cancelEdit: function() {
      var vm = this
      this.message = this.cached_message
      vm.generics = []
      $.each(vm.cached_generics, function(index, generic) {
        vm.generics[index] = Object.assign({}, generic)
        vm.generics[index].buttons = []
        $.each(generic.buttons, function(bindex, button) {
          vm.generics[index].buttons[bindex] = Object.assign({}, button)
        })
      })
      vm.messages = JSON.parse(vm.cached_messages)

      vm.type = vm.cached_type
      vm.isEditWelcome = false
    },
    saveContent: function() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }
        vm.saveWelcomeMessage()
        if (vm.type == 'message') {
          vm.cached_message = vm.message
        } else if (vm.type == 'generic') {
          vm.cached_generics = []
          $.each(vm.generics, function(index, generic) {
            vm.cached_generics[index] = Object.assign({}, generic)
            vm.cached_generics[index].buttons = []
            $.each(generic.buttons, function(bindex, button) {
              vm.cached_generics[index].buttons[bindex] = Object.assign({}, button)
            })
          })
        } else if (vm.type == 'json') {
          vm.cached_messages = JSON.stringify(vm.messages)
        }
        vm.isEditWelcome = false
      })
    },
    addEmoji: function(emoji) {
      this.message += emoji.native
      this.showEmoji = false
    },
    checkMove: function(event) {},
    onMove: function(index, direction) {
      var vm = this
      if (direction == 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction == 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundWelcome = false
          $.each(response.data, function(index, val) {
            var intent = val
            intent.isShow = false
            if (intent.intentname == '{welcome}') {
              isFoundWelcome = true
              intent.ableToDelete = false
              vm.welcome_intent = intent
            }
          })

          if (!isFoundWelcome) {
            vm.welcome_intent = {
              intentname: '{welcome}',
              q_type: 'text',
              a_type: 'json',
              q_val: '',
              a_val: [[]],
              context_in: '',
              context_out: '',
              ableToDelete: false,
              isShow: false
            }
          }
        }
        callback()
      })
    }
  },
  watch: {
    selectedBot: async function() {
      await this.getWelcomeMessage()
    },
    welcome_intent: {
      handler: function(newVal) {
        this.formatData(this.welcome_intent.q_val)
      },
      deep: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/WelcomeMessage.vue